export default "__VITE_ASSET__CUdOsneh__"